import { createContext, useCallback, useContext, useState } from "react";
import { CONTENT } from "@/data/content";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("ac-lang") || "es");

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("ac-lang", l);
    document.documentElement.lang = l;
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: CONTENT[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
